<template>
  <div class="TopicDetail w-full pb-2 bg-white" v-if="topicData !== null">
    <div class="post_content border">
      <div class="article-img mb-4">
        <img class="w-full h-full object-cover" :src="topicData.cover_url" alt="livaABC">
      </div>
      <div class="content px-3 md:px-4 lg:px-6 pb-4 border-b border-dashed borderColordarkgray2">
        <h2 class="mb-4 text-xl font-blod text-black text-NotoSansBold">
          【{{ topicData.category_name }}】{{ topicData.title }}
        </h2>
        <h6 class="mb-4 textColorwhiteGray text-base">Posted on {{ moment(topicData.publish_at).format('YYYY/MM/DD') }}</h6>
        <div class="max-w-4xl mx-auto">
          <div class="leading-loose whitespace-pre-wrap text-NotoSansRegular text-base" v-html="topicData.content"></div>
        </div>
      </div>
      <div class="related-article px-4 py-4 text-NotoSansRegular text-base">
        <h6 class="mb-2 text-NotoSansRegular flex items-center">更多相關文章
          <img class="h-2 ml-1" src="~@/assets/icon/dir.png">
        </h6>
        <ul v-if="relatedData !== null">
          <li class="py-1" v-for="(item, index) in relatedData" :key="index">
            <router-link :to="{ name: 'topicDetail', params: { id: item.id } }" class="related-title mb-1">
              <h6>【{{ item.category_name }}】{{ item.title }}</h6>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <RelatedEvents :title="'其他活動'" />
  </div>
</template>

<script>
import axios from 'axios'
import RelatedEvents from '@/components/modules/RelatedEvents'
export default {
  name: 'ArticleContent',
  metaInfo () {
    return {
      title: this.page_title,
      meta: this.metaInform
    }
  },
  data () {
    return {
      page_title: '',
      metaInform: [],

      topicData: null,
      relatedData: null
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.id !== from.params.id) {
        this.getData()
      }
    }
  },
  components: {
    RelatedEvents
  },
  computed: {
  },
  mounted () {
    this.getData()
  },
  updated () {
  },
  methods: {
    getData () {
      let self = this
      let path = `/article/${self.$route.params.id}`
      axios.get(path)
        .then((response) => {
          self.topicData = response.data
          self.getCategoryArticle(response.data.category.id)

          self.metaInform = [
            { property: 'og:url', content: 'https://store.liveabc.com' + self.$route.path },
            { property: 'og:title', content: response.data.title },
            { property: 'og:image', itemprop: 'image', content: response.data.cover_url }
          ]
        })
    },
    getCategoryArticle (id) {
      // 拿分類的文章
      let self = this
      let path = `/articles?page=1&pageSize=3&category=${id}`
      axios.get(path)
        .then((response) => {
          self.relatedData = response.data.data
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.TopicDetail {
  .post_category:before, .post_author::before {
  content: '/';
  position: relative;
  left: -10px;
}
.article-img {
  max-height: 360px;
  overflow: hidden;
}
.sidebar h4 {
  font-size: 15px;
  letter-spacing: 0px;
  font-weight: 600;
  font-style: normal;
  text-transform: capitalize;
  background: #525050;
  color: white;
  padding: .5rem .6rem;
}
.related-title{
  color: #c7c7c7;
  transition: .3s;
  &:hover {
    color: #e60012;
  }
}
  .categories {
    ul {
    margin: 0px 0px 0px 5px;
    list-style: none;
    line-height: 2em;
      li {
        position: relative;
        &:before {
          position: absolute;
          left: -15px;
          top: 0px;
          content: '';
          display: block;
          border-left: 1px solid #ddd;
          height: 1em;
          border-bottom: 1px solid #ddd;
          width: 10px;
        }
        &:after {
          position: absolute;
          left: -15px;
          bottom: -7px;
          content: '';
          display: block;
          border-left: 1px solid #ddd;
          height: 100%;
        }
        &.root {
          margin: 0px 0px 0px -5px;
          &:before {
            display: none;
          }
          &:after {
            display: none;
          }
        }
        &:last-child {
          &:after {
            display: none;
          }
        }
      }
    }
  }
}
  .text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .related {
    .item {
      max-height: 200px;
      .hoverText {
        z-index: 5;
        color: transparent;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: .3s;
        background: rgba(0, 0, 0, 0);
        &:hover {
          color: rgb(255, 255, 255);
          background: rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
</style>
